export enum IssuerStatus {
    active = 1,
    inactive = 2,
    pending = 4,
    declined = 8,
    archived = 16
}
